const SHOP_BASE_URL = 'https://discoverbecome.com';

export const getShopProductUrl = (slug: string): string =>
  `${SHOP_BASE_URL}/shop/${slug}`;
